import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService as RoleGuard } from './common/auth-guard.service';
import { APP_BASE_HREF } from '@angular/common';
import { HomeComponent } from '../app/inside-of-application/home/home.component';
import { DashboardComponent } from '../app/inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { LocationMasterComponent } from './inside-of-application/Admin/LocationMaster/location-master/location-master.component';
import {
    LocationMasterViewComponent
} from './inside-of-application/Admin/LocationMaster/location-master-view/location-master-view.component';
import {CreateRecoveryComponent} from './inside-of-application/Admin/create-recovery/create-recovery.component';
import { CreateRecoveryViewComponent } from './inside-of-application/Admin/create-recovery-view/create-recovery-view.component';
import { BulkUploadComponent } from './inside-of-application/Admin/bulk-upload/bulk-upload.component';
import { GenerateJournalVoucherComponent } from './inside-of-application/generate-journal-voucher/generate-journal-voucher.component';
import { FinanceRecoveryViewComponent } from './inside-of-application/finance-recovery-view/finance-recovery-view.component';

const routes: Routes = [

    // { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: '', component: LoginComponent },
    // { path: 'ref/:Path', component: LoginComponent},
    { path: 'login', component: LoginComponent },
    { path: 'ref/:Path', component: LoginComponent },
    { path: 'dummylogin', component: DummyLoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'unauthorize', component: UnAuthorizeComponent },
    { path: 'badrequest', component: BadRequestComponent },
    { path: 'pagenotfound', component: PageNotFoundComponent },
    { path: 'sessionexpired', component: SessionExpiredComponent },
    {
        path: 'error/:ID',
        component: PageNotFoundComponent
    },
    {
        path: '', component: HomeComponent,
        children: [
            {
                path: '',
                component: DashboardComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin', 'LocationSPOC', 'Finance']
                }
            },
            {
                path: 'dashboard',
                component: DashboardComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin', 'LocationSPOC', 'Finance']
                }
            },
            {
                path: 'admin/add-location',
                component: LocationMasterComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin']
                }
            },
            {
                path: 'admin/add-location/:ID',
                component: LocationMasterComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin']
                }
            },
            {
                path: 'admin/view-location', canActivate: [RoleGuard],
                component: LocationMasterViewComponent,
                data: {
                    expectedRole: ['Admin']
                }
            }, 
            {
                path: 'admin/create-recovery', canActivate: [RoleGuard],
                component: CreateRecoveryComponent,
                data: {
                    expectedRole: ['Admin','LocationSPOC']
                }
            },
            {
                path: 'admin/create-recovery/:ID',
                component: CreateRecoveryComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin', 'LocationSPOC','Finance']
                }
            }, 
            {
                path: 'admin/view-recovery', canActivate: [RoleGuard],
                component: CreateRecoveryViewComponent,
                data: {
                    expectedRole: ['Admin', 'LocationSPOC']
                }
            },
            {
                path: 'create/upload-Recovery',
                component: BulkUploadComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin', 'LocationSPOC']
                }
            },
            {
                path: 'Generate/JournalVoucher',
                component: GenerateJournalVoucherComponent, canActivate: [RoleGuard],
                data: {
                    expectedRole: ['Admin', 'Finance']
                }
            },
            {
                path: 'Finance/view-recovery', canActivate: [RoleGuard],
                component: FinanceRecoveryViewComponent,
                data: {
                    expectedRole: ['Admin', 'Finance']
                }
            }               
        ]
    },
    {
        path: 'logout', component: LogoutComponent
    },
    { path: '**', redirectTo: 'pagenotfound' },

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    // providers: [{ provide: APP_BASE_HREF, useValue: '/' }, RoleGuard]
})

export class AppRoutingModule {
}
